import { render, staticRenderFns } from "./Isimple.vue?vue&type=template&id=6fdd502c&scoped=true&"
import script from "./Isimple.vue?vue&type=script&lang=js&"
export * from "./Isimple.vue?vue&type=script&lang=js&"
import style0 from "./Isimple.vue?vue&type=style&index=0&id=6fdd502c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdd502c",
  null
  
)

export default component.exports